import React from "react";
import { Tooltip } from "reactstrap";

export default (props) => {
  return (
    <div className="CustomInnerHeader">
      {props.icon && <i className={`mdi ${props.icon}`}></i>}
      <span>{props.displayName}</span>
    </div>
  );
};
